
import { customStylesSelect } from "common/data/settings"
import React, { Fragment } from "react"
import DatePicker from "react-datepicker"
import ReactSelect from "react-select"
import { Col, Row, Form, Label } from "reactstrap"

const Filter = props => {
  const { handleSubmit, setExpandedRow } = props

  const startDateChange = date => {
    setExpandedRow && setExpandedRow(null)
    props.handleDateChange(date, 'start')
  }
  const endDateChange = date => {
    setExpandedRow && setExpandedRow(null)
    props.handleDateChange(date, 'end')
  }

  return (
    <Fragment>
      <Row>
        <Form onSubmit={handleSubmit}>
          <Row className="mb-2 mobile_responsive_user">
            <Col lg={2} className=" justify-content-start">
            <Label className="form-label">Start Date</Label>
              <DatePicker
                dateFormat="yyyy-MM-dd"
                selected={props.startDate}
                onChange={startDateChange}
                className="form-control mb-2 date-icon-back"
                placeholderText="Select date"
                maxDate={new Date()}
              />
            </Col>
            <Col lg={2} className=" justify-content-start">
            <Label className="form-label">End Date</Label>
              <DatePicker
                dateFormat="yyyy-MM-dd"
                selected={props.endDate}
                onChange={endDateChange}
                className="form-control mb-2 date-icon-back"
                placeholderText="Select date"
                minDate={new Date(props.startDate)}
              />
            </Col>
            <Col lg={2} className=" justify-content-start">
              <Label className="form-label">Employee Name</Label>
              <ReactSelect
                className="mb-2"
                value={props.activeUser}
                onChange={value => props.handleActiveUser(value)}
                options={props.allUserLists}
                classNamePrefix="select2-selection"
                placeholder="Select Workfrom home"
                styles={customStylesSelect}
              />
            </Col>
            <Col lg={2} className=" justify-content-start">
              <Label className="form-label">Scrutiny Type</Label>
              <ReactSelect
                className="mb-2"
                value={props.scrutinyType}
                onChange={value => props.handleactivescrutinytypes(value)}
                options={props.scrutinynotesTypelist}
                classNamePrefix="select2-selection"
                placeholder="select Scrutiny Types"
                styles={customStylesSelect}
              />
            </Col>

            <Col lg={2} className=" justify-content-start">
            </Col>

            <Col lg={2} >
              <div className="d-flex mobile_responsive_user mt-4 pt-1">
                <button
                  className="btn btn-primary"
                  type="submit"
                  onClick={handleSubmit}
                  style={{ width: "100%" }}
                >
                  <i className="bx bx-filter-alt align-middle"></i> Filter
                </button>
              </div>
            </Col>
          </Row>
        </Form>
      </Row>
    </Fragment>
  )
}

export default Filter
